import _ from 'lodash'
import YouTubePlayer from 'youtube-player'
import VIDEO_YOUTUBE_CONFIG from './config'
import VIDEOS_VIMEO from '../video-vimeo'
import VIDEOS_NATIVE from '../video-native'

class VideoYoutubeClass {
    constructor( video ) {
        this.DOM = {
            video: video,
            iframe: null,
            player: _.select( '.c-video__player', video ),
            cover: _.select( '.c-video__cover', video ),
            play: _.select( '.c-video__cover-play', video ),
            slide: _.findAncestor( video, 'c-slide' )
        }

        this.player = {
            frame: null,
            params: {
                id: this.DOM.video.getAttribute( 'data-id' ),
                autoplay: JSON.parse( this.DOM.video.getAttribute( 'data-autoplay' ) ),
                host: VIDEO_YOUTUBE_CONFIG.params.host,
                origin: VIDEO_YOUTUBE_CONFIG.params.origin,
                controls: VIDEO_YOUTUBE_CONFIG.params.controls,
                rel: VIDEO_YOUTUBE_CONFIG.params.rel,
                modestbranding: VIDEO_YOUTUBE_CONFIG.params.modestbranding,
                iv_load_policy: VIDEO_YOUTUBE_CONFIG.params.iv_load_policy,
                showinfo: VIDEO_YOUTUBE_CONFIG.params.showinfo,
                color: VIDEO_YOUTUBE_CONFIG.params.color
            },
            controls: {
                play: _.select( '.c-video__play', this.DOM.video ),
                pause: _.select( '.c-video__pause', this.DOM.video ),
                mute: _.select( '.c-video__mute', this.DOM.video ),
                unmute: _.select( '.c-video__unmute', this.DOM.video ),
                fullscreen: _.select( '.c-video__fullscreen', this.DOM.video )
            }
        }


        this.hideContent = this.DOM.slide.getAttribute( 'data-content-hide' ) == 'true' ? true : false
        
        this.init()
    }

    init() {
        this._playerCreate()
        this._playerIsAutoplay()
        this._playerStateChange()
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.play ? this.DOM.play.addEventListener( 'click', this._playTrigger.bind( this ) ) : null
        this.player.controls.play.addEventListener( 'click', this._playerPlayVideo.bind( this ) )
        this.player.controls.pause.addEventListener( 'click', this._playerStopVideo.bind( this ) )
        this.player.controls.mute.addEventListener( 'click', this._playerMuteVideo.bind( this ) )
        this.player.controls.unmute.addEventListener( 'click', this._playerUnmuteVideo.bind( this ) )
    }

    _playerCreate() {
        this.player.frame = YouTubePlayer( this.DOM.player, {
            videoId: this.player.params.id,
            host: this.player.params.host,
            playerVars: {
                'origin': this.player.params.origin,
                'autoplay': this.player.params.autoplay ? 1 : 0,
                'loop': this.player.params.autoplay ? 1 : 0,
                'controls': this.player.params.controls ? 1 : 0,
                'rel': this.player.params.rel,
                'modestbranding': this.player.params.modestbranding,
                'iv_load_policy': this.player.params.iv_load_policy,
                'showinfo': this.player.params.showinfo,
                'color': this.player.params.color
            }
        })
    }



    _playerStateChange() {
        this.player.frame.on( 'stateChange', ( event ) => {
            if ( event.data != 1 ) {
                _.removeClass( this.DOM.video, 'is--playing' )
                this._playerContentShow()
            } else {
                this._playerStopAllExceptCurrent()
                VIDEOS_VIMEO.forEach( ( video ) => { video._playerStopVideo() })
                VIDEOS_NATIVE.forEach( ( video ) => { video._playerStopVideo() })
                _.addClass( this.DOM.video, 'is--playing' )
                this._playerContentHide()
            }
        })

        this.player.frame.on( 'ready', () => {
            this.DOM.iframe = _.select( 'iframe', this.DOM.video )
            this.player.controls.fullscreen.addEventListener( 'click', this._playerFullscreenVideo.bind( this ) )
        })
    }

    _playerContentHide() {
        this.hideContent ? _.addClass( this.DOM.slide, 'is--content-hide' ) : null
    }

    _playerContentShow() {
        this.hideContent ? _.removeClass( this.DOM.slide, 'is--content-hide' ) : null
    }

    _playerStopVideo() {
        this.player.frame.stopVideo()
    }

    _playerPlayVideo() {
        this.player.frame.playVideo()
    }

    _playerMuteVideo() {
        this.player.frame.mute()
        _.addClass( this.DOM.video, 'is--muted' )
    }
    _playerUnmuteVideo() {
        this.player.frame.unMute()
        _.removeClass( this.DOM.video, 'is--muted' )
    }

    _playerFullscreenVideo() {
        this.DOM.iframe.requestFullscreen()
    }

    _playerIsAutoplay() {
        if ( this.player.params.autoplay ) {
            this._playerMuteVideo()
            _.addClass( this.DOM.video, 'is--muted' )
        }
    }

    _playerStopAll() {
        VIDEOS_YOUTUBE.forEach( ( video ) => {
            video._playerStopVideo()
        })
    }

    _playerStopAllExceptCurrent() {
        const VIDEOS_YOUTUBE_EXCEPT_CURRENT = VIDEOS_YOUTUBE.filter( e => e.player.params.id != this.player.params.id )
        VIDEOS_YOUTUBE_EXCEPT_CURRENT.forEach( ( video ) => {
            video._playerStopVideo()
        })
    }

    _playTrigger() {
        this._playerPlayVideo()
    }

} 

const VIDEOS_YOUTUBE = []
VIDEO_YOUTUBE_CONFIG.videos.forEach( ( video ) => { VIDEOS_YOUTUBE.push( new VideoYoutubeClass( video ) ) } )
export default VIDEOS_YOUTUBE